import { from, merge, of } from "rxjs";
import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectBuildingInfoById } from "../../../../selectors/selectExistingBuildingInfo";
import { BuildingStateType, CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionBaseInfoUpdateBuilding } from "../../../info/base/actionBaseInfo";
import { actionPlayerInfoAddBuffs, actionPlayerInfoAddXp, } from "../../../info/player/actionPlayerInfo";
import { actionBuildingsAddPellets, actionBuildingsDeselect, TypeActionBuildings, } from "../actionBuildings";
import { TypeBuildingAction } from "../reducerBuildings";
export var epicBuildingFinishConstruction = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.Select &&
            action.action === TypeBuildingAction.Select;
    }), map(function (action) {
        // refresh building because it might be outdated when coming from another action
        return selectBuildingInfoById(state$.value, action.building.proto.id);
    }), filter(utilBuildings.hasFinishedConstruction), switchMap(function (building) {
        var state = state$.value;
        var isUpgrade = building.proto.state === BuildingStateType.UPGRADING;
        return merge(deps
            .netSend({
            id: isUpgrade ? CommandCode.FinishUpgrade : CommandCode.FinishConstruct,
            props: {
                buildingId: building.proto.id,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            var actions = [];
            if (res.buff.length > 0) {
                actions.push(actionPlayerInfoAddBuffs(res.buff));
            }
            actions.push(actionBaseInfoUpdateBuilding({
                id: res.buildingId,
                stage: isUpgrade
                    ? utilBuildings.getNextProtoStage(building)
                    : utilBuildings.getProtoStage(building),
                state: BuildingStateType.IDLE,
            }), actionPlayerInfoAddXp(res.xp), actionBuildingsAddPellets(building));
            return from(actions);
        }))
            .pipe(retry()), of(actionBuildingsDeselect()));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingFinishConstruction.ts
// module id = 2045
// module chunks = 3